// extracted by mini-css-extract-plugin
module.exports = {"panel":"unauthorized-panel_panel___s33I"};